<template>
	<v-layout 
		wrap 
		class="section-generate-app" 
		id="generate-app"
		justify-center>
		<v-flex xs12 md6 class="pr-16 max-600">
			<div>
				<form-generate-app
					:disabled-register-app="disabledRegisterApp"
					:departaments="departaments"
					:token="token"
					@change-background="changeBackground"
					@change-color="changeColor"
					@change-logo="changeLogo"
				/>
			</div>
		</v-flex>
		<v-flex xs12 md6 class="pl-16 max-600">
			<section-phone
				:background="background"
				:color-select="colorSelect"
				:loading-background="loadingBackground"
				:loading-color="loadingColor"
				:loading-logo="loadingLogo"
				:logo="logo"
				:theme-id="colorSelect.id"
			/>
		</v-flex>
	</v-layout>
</template>
<script>
import formGenerateApp from '@/components/generate-app/form-generate-app';
import sectionPhone from '@/components/generate-app/section-phone';

function changeColor(item) {
	this.loadingColor = true;
	this.logo = this.logo.includes('/themes/') ?
		`/static/images/themes/theme-${item.id}-logo.svg` : this.logo;
	this.colorSelect = { ...item };
	setInterval(() => {
		this.loadingColor = false;
	}, 1000);
}

function changeLogo({ value, loading }) {
	this.loadingLogo = loading;
	this.logo = value;
	setInterval(() => {
		this.loadingLogo = false;
	}, 1500);
}

function changeBackground({ value, loading }) {
	this.loadingBackground = loading;
	this.background = value;
	setInterval(() => {
		this.loadingBackground = false;
	}, 1500);
}

function data() {
	return {
		background: '/static/images/simulator/background-default.png',
		colorSelect: {
			fifth: '#000000',
			fourth: '#ffffff',
			id: 1,
			primary: '#02979b',
			secondary: '#b1dc03',
			tertiary: '#085f65',
		},
		loadingBackground: false,
		loadingColor: false,
		loadingLogo: false,
		logo: '/static/images/themes/theme-1-logo.svg',
	};
}

export default {
	name: 'section-generate-app',
	data,
	components: {
		formGenerateApp,
		sectionPhone,
	},
	methods: {
		changeBackground,
		changeColor,
		changeLogo,
	},
	props: {
		disabledRegisterApp: {
			type: Boolean,
			default: false,
		},
		token: String,
		departaments: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
<style lang="scss" scoped>
	.section-generate-app {
		padding: 16px 7% 70px;
		position: relative;

		@media (max-width: 959px) {
			background-color: color(white);
			padding: 50px 0;
		}

		// @media (min-width: 1350px) {
		// 	padding: 6px 0 70px;
		// }

		.pr-16 {
			padding-right: 16px;

			@media (max-width: 959px) {
				padding-right: 0px;
			}
		}

		.pl-16 {
			padding-left: 16px;

			@media (max-width: 959px) {
				padding-left: 0px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/generate-app/section-generate-app.vue